import { makeAutoObservable, onBecomeObserved, runInAction } from 'mobx';
import { v4 as UUID } from 'uuid';
import { MindfulnessProgramTemplateDayUnit, createMindfulnessProgramTemplateDayUnit } from './MindfulnessProgramTemplateDayUnit';
import { BreathingTechniqueStep, createBreathingTechniqueStep } from '../../../Explore/BreathingTechniqueStep';
import { ConditionalMedia, createConditionalMedia } from '../../SuperMacro/ConditionalMedia';
import { ActivityApi } from '../../../Activity/Activity';

/**
 * Created by neo on 12.04.22.
 */

export type MindfulnessProgramTemplateDayUnitBreathing = MindfulnessProgramTemplateDayUnit & {
  technique: BreathingTechniqueStep[];
  backgroundImages: ConditionalMedia[];
  spotifyPlaylistLink?: string;
};

export function createMindfulnessProgramTemplateDayUnitBreathing(json?: Partial<MindfulnessProgramTemplateDayUnitBreathing>): MindfulnessProgramTemplateDayUnitBreathing {
  const base = createMindfulnessProgramTemplateDayUnit({ ...json, type: 'breathing' } as any);
  const unit: MindfulnessProgramTemplateDayUnitBreathing = makeAutoObservable({
    ...base,
    technique: (json?.technique ?? []).map((a: any) => createBreathingTechniqueStep(a)),
    backgroundImages: (json?.backgroundImages ?? []).map((m: any) => createConditionalMedia(m)),
    spotifyPlaylistLink: json?.spotifyPlaylistLink,

    toJS(newId: boolean = false) {
      return {
        ...(function() { const { id, createdAt, updatedAt, createdBy, updatedBy, name, description } = base; return { id: newId ? UUID() : id, createdAt, updatedAt, createdBy, updatedBy, name, description }; })(),
        technique: this.technique.map((a) => a),
        backgroundImages: this.backgroundImages.map((m) => m),
        spotifyPlaylistLink: this.spotifyPlaylistLink,
      };
    },
  });

  onBecomeObserved(unit, 'activity', () => {
    if (!unit.activity) {
      ActivityApi.get(unit.activityIdentifier).then((result) => runInAction(() => (unit.activity = result)));
    }
  });

  return unit;
}
